import { Trash2, Pencil, MapPin } from "lucide-react";

export const TravelCostListItem = ({ tc, onEdit, onDelete }) => (
  <div
    data-testid={`admin-travel-cost-item-${tc.id}`}
    className="flex items-center justify-between border rounded px-4 py-3"
  >
    <div className="flex items-center gap-2">
      <MapPin size={16} className="text-muted-foreground shrink-0" />
      <p className="text-sm font-medium">{tc.city} — ${Number(tc.price).toLocaleString("es-MX")}</p>
    </div>
    <div className="flex gap-2 shrink-0">
      <button data-testid={`admin-travel-cost-edit-${tc.id}`} onClick={onEdit}><Pencil size={16} /></button>
      <button data-testid={`admin-travel-cost-delete-${tc.id}`} onClick={onDelete}><Trash2 size={16} /></button>
    </div>
  </div>
);
